<template>
<v-dialog max-width="1000px" persistent v-model="dialog" scrollable>
    <v-card>
    <v-toolbar dark>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false) && $emit('setEditIndex',-1)">close</v-icon>
    </v-toolbar>

    <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap>
                <v-flex xs12 sm6 class="px-2">
                    <v-text-field label="First name"></v-text-field> 
                </v-flex>
                <v-flex xs12 sm6 class="px-2">
                    <v-text-field label="Last name"></v-text-field> 
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm6 md6 class="px-2">
                    <v-text-field label="Email"></v-text-field> 
                </v-flex>
                <v-flex xs3 sm2 md1 class="px-2">
                    <v-select :items="country_tel" v-model="user_country_tel" label="Select"></v-select>
                </v-flex>
                <v-flex xs9 sm4 md5 class="px-2">
                    <v-text-field label="Tel."></v-text-field> 
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm6 class="px-2">
                    <v-select :items="country_item" item-text="name" label="Country"></v-select> 
                </v-flex>
                <v-flex xs12 sm6 class="px-2">
                    <v-select :items="province_item" item-text="name" label="Province"></v-select>
                </v-flex>
            </v-layout>
            <!-- <v-select  class="px-2" :items="status_item" item-text="name" label="Status"></v-select> -->
            <div class="line-setpass" v-if="editedIndex===-1"></div>
            <div class="line-editpass" v-else></div>
            <v-text-field label="Username"></v-text-field>
            <v-text-field v-model="password1" :append-icon="show1 ? 'visibility_off' : 'visibility'" :type="show1 ? 'text' : 'password'" name="input-1" label="Password" hint="At least 6 characters" class="input-group--focused" @click:append="show1 = !show1"></v-text-field>
            <v-text-field v-model="password2" :append-icon="show2 ? 'visibility_off' : 'visibility'" :type="show2 ? 'text' : 'password'" name="input-2" label="Confirm Password" hint="At least 6 characters" class="input-group--focused" @click:append="show2 = !show2"></v-text-field>
        </v-form>
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="$emit('setDialog', false) && $emit('setEditIndex',-1)">Cancel</v-btn>
        <v-btn color="green" flat>Save</v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    props: ["dialog", "editedIndex"],
    data() {
        return {
            password1: '',
            password2: '',
            show1: false,
            show2: false,
            valid: true,
            user_country_tel: '+66',
            country_tel: ['+66'],
            country_item: [{
                name: 'Thailand',
                value: 1
            }],
            province_item: [{
                name: 'Phuket',
                value: 1
            },
            {
                name: 'Trang',
                value: 2
            },
            {
                name: 'Suratthani',
                value: 3
            }],
            // status_item: [{
            //     name: 'Active',
            //     value: 1
            // },
            // {
            //     name: 'Inactive',
            //     value: 2
            // }]
        }
    },
    computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New hub"
        : "Edit hub";
    }
  }
}
</script>
<style scoped>
.line-setpass {
        overflow: visible;
        padding: 0;
        border: none;
        border-top: 2px solid black;
        color: #333;
        text-align: center;
        margin-top: 25px;
    }
.line-setpass:after {
        content: "Set Password";
        display: inline-block;
        position: relative;
        top: -0.8em;
        font-size: 17px;
        padding: 0 0.25em;
        background: white;
    }
    .line-editpass {
        overflow: visible;
        padding: 0;
        border: none;
        border-top: 2px solid black;
        color: #333;
        text-align: center;
        margin-top: 25px;
    }
.line-editpass:after {
        content: "Edit Password";
        display: inline-block;
        position: relative;
        top: -0.8em;
        font-size: 17px;
        padding: 0 0.25em;
        background: white;
    }
</style>




